import '../styles/Welcome.css';

function Welcome() {
    return (
        <div>
            <div className="background-image">
            <section className="welcome flex flex-col items-end justify-center">
                <h2 className="h1 text-white mb-0">Welcome to</h2>
                <h1 className="text-white">Wild Violet Counseling</h1>
                <h4 className="text-white">Mental health therapy rooted in flexibility, curiosity and authenticity</h4>
            </section>
            </div>
        </div>
    )
};

export default Welcome;